import { render, staticRenderFns } from "./PartnersSideview.vue?vue&type=template&id=02fe2404&scoped=true&class=fill-height&"
import script from "./PartnersSideview.vue?vue&type=script&lang=ts&"
export * from "./PartnersSideview.vue?vue&type=script&lang=ts&"
import style0 from "./PartnersSideview.vue?vue&type=style&index=0&id=02fe2404&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fe2404",
  null
  
)

export default component.exports